import { Button, Text, Image, Card } from "@fluentui/react-components";
import { Dismiss20Regular, Open16Regular } from "@fluentui/react-icons";
import { IPromotionProps } from "../../../hooks/types";
import Cookies from "js-cookie";
import { cookieExpiry } from "../../../utility/app-constants";

/**
 * Banner shelf card
 * @param props 
 * @returns 
 */
export default function BannerCard(props: IPromotionProps) {

    /* function to dismiss the banner on close icon click */
    const dismissBanner = () => {
        Cookies.set(props.promotionTitle, 'true', { expires: cookieExpiry, sameSite: 'none', secure: true })
        props.setIsBannerVisible(false);
    }

    return (
        <Card className="banner-card" data-testid="banner-card">
            <div className="banner-wrapper">
                <div className="banner-left-section">
                    <Text size={500} weight="bold">{props.promotionTitle}</Text>
                    <div className="banner-sub-title"><Text size={400} weight="bold">{props.promotionBody}</Text></div>
                    <div>
                        <a href={props.linkHref} target="_blank">
                            <Button appearance="primary" icon={<Open16Regular />}>
                                {props.callToAction}
                            </Button>
                        </a>
                    </div>
                </div>
                <div className="banner-right-section">
                    <Image alt={props.altText} block={true} src={props.imageURL} fit="contain" className="banner-img" />
                    <div className="dismiss-icon" onClick={() => dismissBanner()} data-testid="dismiss-icon"><Dismiss20Regular /></div>
                </div>
            </div>
        </Card>
    );
}
